import { Component, OnInit, OnDestroy } from "@angular/core";
import { NavigationService } from "../../../providers/navigation.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ApiService } from "../../../providers/api.service";
import { Subscription } from "rxjs";
import { SM_CONSTANTS } from "../../../shared/constants/sm-constants";
import { ITableColumnHeader } from "../../../models/table-column-header";
import { AddServiceComponent } from "src/app/shared/components/add-service/add-service.component";
import { MatDialog } from "@angular/material/dialog";
import { SharedService } from "../../../providers/shared.service";
import { UntypedFormControl } from "@angular/forms";
import { AddServiceTemplateItemComponent } from "src/app/shared/components/add-service-template-item/add-service-template-item.component";
import { MessagingService } from "src/app/providers/messaging.service";
import { AngularFireMessaging } from "@angular/fire/compat/messaging";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { TranslateService } from "@ngx-translate/core";
import { PaymentIntimationComponent } from "src/app/shared/components/payment-intimation/payment-intimation.component";
import { YoutubeEmbedVideoComponent } from "../../new-v2-pages/new-v2-component/youtube-embed-video/youtube-embed-video.component";
import { AddMemberComponent } from "src/app/shared/components/add-member/add-member.component";
import { MemberViewDetailsComponent } from "src/app/shared/components/member-view-details/member-view-details.component";
import { CreateInvoiceForFitnessComponent } from "src/app/shared/components/create-invoice-for-fitness/create-invoice-for-fitness.component";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { MarkAbsentComponent } from "../../new-v2-pages/new-v2-component/mark-absent/mark-absent.component";
import { PhoneCheckForMemberComponent } from "../../new-v2-pages/new-v2-component/phone-check-for-member/phone-check-for-member.component";
import { DialogService } from "src/app/providers/dialog.service";
import { Share } from "@capacitor/share";
import { AuthService } from "src/app/providers/auth.service";
import { AutoInvoicingSettingComponent } from "../../new-v2-pages/new-v2-component/auto-invoicing-setting/auto-invoicing-setting.component";

@Component({
  selector: "sm-members",
  templateUrl: "./members.component.html",
  styleUrls: ["./members.component.scss"],
})
export class MembersComponent implements OnInit, OnDestroy {
  memberData: any = {};
  isOwner: boolean = false;
  entityHashId: string = "";
  isEntityIndividual: any = sessionStorage.getItem("isEntityIndividual");
  // clickEventSubscription: Subscription
  public loader: boolean = false;
  customersData: any[] = [];
  membersData: any[] = [];
  private _apiSubscription: Subscription;
  datalength!: number;
  public page: number = 1;
  searchString: UntypedFormControl = new UntypedFormControl("");
  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: "name",
      columnProperty: "name",
    },
    {
      columnName: "phone",
      columnProperty: "member_phone",
    },
    {
      columnName: "gender",
      columnProperty: "gender",
    },
    {
      columnName: "last payment date",
      columnProperty: "last_payment_date",
    },
    {
      columnName: "Service mode",
      columnProperty: "s_mode",
    },
    {
      columnName: "total due",
      columnProperty: "total_due",
    },
  ];
  discountInfo: any = null;
  constructor(
    private _navService: NavigationService,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private _apiService: ApiService,
    private _modelRef: MatDialog,
    private sharedService: SharedService,
    private messagingService: MessagingService,
    private angularFireMessaging: AngularFireMessaging,
    private loaderservice: LoaderServiceService,
    private translateService: TranslateService,
    private router: Router,
    private dialogService: DialogService,
    private authService: AuthService,
  ) {
    this._navService.hideSidebarAndNav = false;
    // this.clickEventSubscription = this.sharedService.getClickEvent().subscribe(() => {
    //   this.ngOnInit();
    // })

    this._apiSubscription = this._apiService.apiResult.subscribe((resData) => {
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_GET_ENROLL_MEMBERS_SEARCH_BY_TYPE
      ) {
        this.membersData = [];
        console.log(resData);
        if (resData.result && resData.result != null) {
          resData.result.forEach((element: any) => {
            Object.keys(element).forEach((key) => {
              // if ((element as any)[key] === null) {
              //   // delete (data as any)[key];
              //   if (
              //     key != "image_thumb_url" &&
              //     key != "last_payment_date" &&
              //     key != "membership_start_date" &&
              //     key != "email" &&
              //     key != "dob" &&
              //     key != "products" &&
              //     key != "custom_items" &&
              //     key != "services" &&
              //     key != "discount_amount " &&
              //     key != "coupon_code"
              //   ) {
              //     (element as any)[key] = "N/A";
              //   }
              // }

              if (element.service_mode == 0) {
                element.s_mode = "Home service";
              } else if (element.service_mode == 1) {
                element.s_mode = "In-premise service";
              } else if (element.service_mode == 2) {
                element.s_mode = "Virtual service";
              }

              if (element.coupon_info) {
                element.coupon_info =
                  typeof element.coupon_info == "string"
                    ? JSON.parse(element.coupon_info)
                    : element.coupon_info;
              }

              element.member_phone = element.country_code + " " + element.phone;
            });
            this.membersData.push(element);
          });
        }
        this._apiService.getBillDiscountData(
          localStorage.getItem(
            SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID,
          ),
        );
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_GET_MEMBER_DATA_BY_KEYWORD
      ) {
        this.membersData = [];
        console.log(resData);
        if (resData.result && resData.result != null) {
          resData.result.forEach((element: any) => {
            Object.keys(element).forEach((key) => {
              // if ((element as any)[key] === null) {
              //   // delete (data as any)[key];
              //   if (
              //     key != "image_thumb_url" &&
              //     key != "last_payment_date" &&
              //     key != "membership_start_date" &&
              //     key != "email" &&
              //     key != "dob" &&
              //     key != "products" &&
              //     key != "custom_items" &&
              //     key != "services" &&
              //     key != "discount_amount " &&
              //     key != "coupon_code"
              //   ) {
              //     (element as any)[key] = "N/A";
              //   }
              // }

              if (element.service_mode == 0) {
                element.s_mode = "Home service";
              } else if (element.service_mode == 1) {
                element.s_mode = "In-premise service";
              } else if (element.service_mode == 2) {
                element.s_mode = "Virtual service";
              }

              if (element.coupon_info) {
                element.coupon_info =
                  typeof element.coupon_info == "string"
                    ? JSON.parse(element.coupon_info)
                    : element.coupon_info;
              }

              element.member_phone = element.country_code + " " + element.phone;
            });
            this.membersData.push(element);
          });
        }
        // this._apiService.getBillDiscountData(
        //   localStorage.getItem(SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID)
        // );
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_ENROLL_MEMBERS
      ) {
        if (resData.result) {
          if (resData.result.errorcode == 0) {
            if (
              resData.result.whatsapp_share == 0 &&
              (resData.result.email_share == 1 ||
                resData.result.email_share == 2 ||
                resData.result.email_share == 3)
            ) {
              const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
                width: "500px",
                data: {
                  title: "Pack expired!",
                  message:
                    "Enrolment successfully done for the new member. But unable to send the confirmation via WhatsApp as Premium pack expired for this business. ",
                  okbtn: "Buy pack",
                  cancelbtn: "Cancel",
                  type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
                },
                disableClose: true,
              });
              dialogRef.afterClosed().subscribe((result) => {
                console.log(result);
                if (result) {
                  this.router.navigate(
                    ["/businesses", "details", "plan-and-renew"],
                    {
                      queryParams: { entityHash: this.entityHashId },
                    },
                  );
                }
              });
            } else if (
              resData.result.whatsapp_share == 1 &&
              resData.result.email_share == 0
            ) {
              const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
                width: "500px",
                data: {
                  title: "Pack expired!",
                  message:
                    "Enrolment successfully done for the new member. But unable to send the confirmation Email as Premium pack expired for this business. ",
                  okbtn: "Buy pack",
                  cancelbtn: "Cancel",
                  type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
                },
                disableClose: true,
              });
              dialogRef.afterClosed().subscribe((result) => {
                console.log(result);
                if (result) {
                  this.router.navigate(
                    ["/businesses", "details", "plan-and-renew"],
                    {
                      queryParams: { entityHash: this.entityHashId },
                    },
                  );
                }
              });
            } else if (
              resData.result.whatsapp_share == 0 &&
              resData.result.email_share == 0
            ) {
              const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
                width: "500px",
                data: {
                  title: "Pack expired!",
                  message:
                    "Enrolment successfully done for the new member. But unable to send the confirmation via Email and WhatsApp as Premium pack expired for this business. ",
                  okbtn: "Buy pack",
                  cancelbtn: "Cancel",
                  type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
                },
                disableClose: true,
              });
              dialogRef.afterClosed().subscribe((result) => {
                console.log(result);
                if (result) {
                  this.router.navigate(
                    ["/businesses", "details", "plan-and-renew"],
                    {
                      queryParams: { entityHash: this.entityHashId },
                    },
                  );
                }
              });
            }
            this._apiService.getEnrolledMembersListByType(
              this.entityHashId,
              this.selectedValue,
              this.pageNo,
            );
          }
          // this.loaderservice.showLoader = false
          // this.activemodal.close({msg: 'success'})
        }
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_DISCOUNT
      ) {
        this.discountInfo = null;
        if (resData.result) {
          this.discountInfo = resData.result;
        }
        this.loader = false;
        this.loaderservice.showLoader = false;
      }

      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_UPDATE_ENROLLED_MEMBER_MEMBERSHIP_STATUS
      ) {
        if (resData.result) {
          this._apiService.getEnrolledMembersListByType(
            this.entityHashId,
            this.selectedValue,
            this.pageNo,
          );
        }
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_RECORD_FITNESS_INVOICE
      ) {
        if (resData.result) {
          this._apiService.getEnrolledMembersListByType(
            this.entityHashId,
            this.selectedValue,
            this.pageNo,
          );
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_ADD_EDIT_FITNESS_INTERNATIONAL_INVOICE_PAYMENT_RECORD
      ) {
        if (resData.result) {
          this._apiService.getEnrolledMembersListByType(
            this.entityHashId,
            this.selectedValue,
            this.pageNo,
          );
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_DELETE_ENTITY_MEMBER_DATA
      ) {
        if (resData.result) {
          this._apiService.getEnrolledMembersListByType(
            this.entityHashId,
            this.selectedValue,
            this.pageNo,
          );
        }
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_DELETE_ENTITY_INVOICE
      ) {
        if (resData.result) {
          this._apiService.getEnrolledMembersListByType(
            this.entityHashId,
            this.selectedValue,
            this.pageNo,
          );
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_DELETE_INTERNATIONAL_INVOICE_DETAILS
      ) {
        if (resData.result) {
          this._apiService.getEnrolledMembersListByType(
            this.entityHashId,
            this.selectedValue,
            this.pageNo,
          );
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_ADD_EDIT_FITNESS_ENTITY_INVOICE
      ) {
        if (resData.result) {
          this._apiService.getEnrolledMembersListByType(
            this.entityHashId,
            this.selectedValue,
            this.pageNo,
          );
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_ADD_EDIT_INTERNATIONAL_FITNESS_ENTITY_INVOICE
      ) {
        if (resData.result) {
          this._apiService.getEnrolledMembersListByType(
            this.entityHashId,
            this.selectedValue,
            this.pageNo,
          );
        }
      }
      //   else if(resData.responseType === SM_CONSTANTS.ADD_UPDATE_SERVICE_TYPE_RESULT){
      //     if(resData.result && resData.result != null){
      //       this._apiService.getServices(this.entityHashId, this.selectedValue, this.page.toString())
      //     }
      //   }
    });
    console.log(this.customersData);
    if (
      !localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) ||
      localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == null ||
      localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == "null"
    ) {
      this.messagingService.requestPermission();
    }
    this.translateService.onLangChange.subscribe(() => {
      // Update your column headers when the language changes
      this.updateColumnHeaders();
    });
  }
  private updateColumnHeaders() {
    this.tableDisplayColumns.forEach((column, index) => {
      let data = ["name", "phone", "gender", "last_booking", "payment_due"];

      // Update each column header with the translated value
      column.columnName = this.translateService.instant(
        `customers.column_headers.${data[index]}`,
      );
    });
  }
  // private modelSubscription: Subscription = new Subscription();
  pageNo: number = 1;
  ngOnInit(): void {
    this.isOwner = this.authService.isOwner();
    sessionStorage.removeItem("mefrp");
    this.isEntityIndividual = sessionStorage.getItem("isEntityIndividual");

    this.loader = true;
    this.loaderservice.showLoader = true;
    this.route.queryParams.subscribe((data) => {
      console.log(data.entityHash);
      this.entityHashId = data.entityHash;
    });

    this._apiService.getEnrolledMembersListByType(
      this.entityHashId,
      this.selectedValue,
      this.pageNo,
    );
    // this.modelSubscription = this._modelRef.afterAllClosed.subscribe((data) => {
    //   this.loader = true;
    //   this._apiService.getServices(this.entityHashId)
    // });
  }
  selectedValue: string = "1";
  changeChip(value: string) {
    this.selectedValue = value;
    this.loader = true;
    this.loaderservice.showLoader = true;
    this._apiService.getEnrolledMembersListByType(
      this.entityHashId,
      this.selectedValue,
      this.pageNo,
    );
  }
  createNotification(title: any, text: any) {
    const noti = new Notification(title, {
      body: text,
    });
  }

  onCreateNewService() {
    this._modelRef.open(AddServiceComponent, {
      width: "700px",
      data: {
        title: "Add service",
        type: SM_CONSTANTS.SERVICE_ADD_UPDATE,
        ref: this._modelRef,
      },
    });
  }

  createInvoice() {
    let data = {
      entityHash: this.entityHashId,
      discountInfo: this.discountInfo,
    };

    this.dialog.open(CreateInvoiceForFitnessComponent, {
      width: "700px",
      data: {
        title: "New Invoice",
        ref: this.dialog,
        data: data,
      },
    });
  }
  onCreateNewServiceFromTemplate() {
    this._modelRef.open(AddServiceTemplateItemComponent, {
      width: "1000px",
      data: {
        title: "Add service From Template",
        ref: this._modelRef,
      },
    });
  }

  deactivateService(rowvalue: any) {
    console.log(rowvalue);
    let metadata = {
      serviceTypeInfo: {
        hash_id: rowvalue.hash_id,
        status: 7,
      },
    };

    this._apiService.addUpdateServiceType(metadata, this.entityHashId);

    // setTimeout(() => {
    //   this.ngOnInit();
    // }, 1500);
  }

  activateService(rowvalue: any) {
    console.log(rowvalue);
    let metadata = {
      serviceTypeInfo: {
        hash_id: rowvalue.hash_id,
        status: 1,
      },
    };

    this._apiService.addUpdateServiceType(metadata, this.entityHashId);

    // setTimeout(() => {
    //   this.ngOnInit();
    // }, 1500);
  }

  deleteService(rowvalue: any) {
    let metadata = {
      serviceTypeInfo: {
        hash_id: rowvalue.hash_id,
        isDelete: 1,
      },
    };

    this._apiService.addUpdateServiceType(metadata, this.entityHashId);

    // setTimeout(() => {
    //   this.ngOnInit();
    // }, 1500);
  }

  onEdit(rowvalue: any) {
    this._modelRef.open(AddServiceComponent, {
      width: "700px",
      data: {
        title: "Edit service",
        type: SM_CONSTANTS.SERVICE_ADD_UPDATE,
        ref: this._modelRef,
        data: rowvalue,
      },
    });
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
    // this.clickEventSubscription.unsubscribe();
    // this.modelSubscription.unsubscribe();
  }

  onPageChange(ev: any) {
    console.log(ev?.pageIndex + 1);
    this.page = ev?.pageIndex + 1;

    this._apiService.getServices(
      this.entityHashId,
      this.selectedValue,
      this.page.toString(),
    );
  }

  firstTimeBelow3: boolean = false;

  searchServiceData() {
    if (this.searchString.value.length >= 3) {
      this.firstTimeBelow3 = true;
      this.page = 1;
      this._apiService.getMemberDataByKeyword(
        this.entityHashId,
        this.page.toString(),
        this.searchString.value,
        this.selectedValue,
      );
    } else {
      if (this.firstTimeBelow3) {
        this.firstTimeBelow3 = false;
        this.page = 1;
        this._apiService.getEnrolledMembersListByType(
          this.entityHashId,
          this.selectedValue,
          this.pageNo,
        );
      }
    }
  }

  reset() {
    this.firstTimeBelow3 = false;
    this.searchString.reset();
    this.page = 1;
    this._apiService.getEnrolledMembersListByType(
      this.entityHashId,
      this.selectedValue,
      this.pageNo,
    );
  }
  openAllInvoices(item: any) {
    sessionStorage.setItem("mefrp", item.email);
    sessionStorage.setItem("currentSelectedMember", item.hash_id);
    console.log(item);

    this.router.navigate(
      ["/businesses", "details", "members", "all-payments"],
      {
        queryParamsHandling: "merge",
        queryParams: {
          memberHash: item.hash_id,
          phone: item.phone,
          code: item.country_code,
          mn: item.name,
        },
      },
    );
  }
  openDueInvoices(item: any) {
    sessionStorage.setItem("mefrp", item.email);
    sessionStorage.setItem("currentSelectedMember", item.hash_id);
    this.router.navigate(
      ["/businesses", "details", "members", "due-payments"],
      {
        queryParamsHandling: "merge",
        queryParams: {
          memberHash: item.hash_id,
          phone: item.phone,
          code: item.country_code,
          mn: item.name,
        },
      },
    );
  }
  msg: any = "";
  openPaymentIntimation(item: any) {
    let data = {
      title: "Payment Intimation",
      ref: this._modelRef,
      data: item,
      type: 2,
      entity_hash: this.entityHashId

    }
    this.dialogService.openFullScreenDialog(PaymentIntimationComponent,data);
  }


  addmember() {
    let data = {
      entityHash: this.entityHashId,
      // serviceType: this.interestType,
    };

    let dialogref = this.dialog.open(PhoneCheckForMemberComponent, {
      width: "500px",
      data: {
        title: "Add member",
        ref: this.dialog,
        data: data,
        entityHash: this.entityHashId,
      },
    });
    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        // this.loader = true
        // this.loaderservice.showLoader = true
        // this._apiService.getEnrolledMembersListByType(this.entityHashId,this.selectedValue,this.pageNo)
      }
    });
  }
  openmarkabsent(rowvalue: any) {
    this.dialog.open(MarkAbsentComponent, {
      width: "500px",
      disableClose: true,
      data: {
        link: "",
        title: "Mark absent",
        entityHash: this.entityHashId,
        memberHash: rowvalue.hash_id,
      },
    });
  }

  // openmarkabsent(){
  //   this.dialog.open(MarkAbsentComponent,{
  //     width:'500px',
  //     disableClose:true,
  //     data:{
  //       link:"",
  //       title: 'Mark absent'
  //     }})
  // }

  customerviewdetails(member: any) {
    this.loaderservice.showLoader = true;
    this.dialog.open(MemberViewDetailsComponent, {
      width: "750px",
      disableClose: true,
      data: {
        link: "",
        title: "Add member",
        memberHash: member.hash_id,
        entityHash: this.entityHashId,
      },
    });
  }

  createInvoiceForEnrolled(item: any) {
    sessionStorage.setItem("mefrp", item.email);
    let data = {
      title: "New Invoice",
      ref: this.dialog,
      data: {
        entityHash: this.entityHashId,
        // serviceType: this.interestType,
        enrolledData: {
          customer_name: item.name,
          customer_country_code: item.country_code,
          customer_phone: item.phone,
          customer_email: item.email,
        },
        memberData: item,
        discountInfo: this.discountInfo,
      },
    };

    this.dialogService.openFullScreenDialog(
      CreateInvoiceForFitnessComponent,
      data,
    );
  }

  openvideo() {
    this.dialog.open(YoutubeEmbedVideoComponent, {
      width: "1000px",
      disableClose: true,
      data: {
        link: "https://www.youtube.com/embed/5XGw3XH_RRE",
        title: "How to manage members?",
      },
    });
  }

  opencontact() {
    this.router.navigate(["/contact-us"]);
  }

  updateEnrolledMemberMembershipStatus(item: any, status: any) {
    let msg = "";
    if (status == 1) {
      msg = "revive";
    } else if (status == 2) {
      msg = "cancel";
    }

    const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
      width: "500px",
      data: {
        title: "Alert",
        message:
          "Are you sure you want to " + msg + " the membership of this member?",
        cancelbtn: "Cancel",
        okbtn: "Confirm",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        let obj = {
          memberHash: item.hash_id,
          entityHash: this.entityHashId,
          membershipStatus: status,
          currentDate: this.formatDate1(new Date()),
        };

        this.loaderservice.showLoader = true;
        this._apiService.updateEnrolledMemberMembershipStatus(obj);
      }
    });
  }

  formatDate1(dateStr: Date) {
    let curdate = new Date(dateStr)
      .toLocaleString("en-CA", {
        timeZone: "Asia/Kolkata",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .slice(0, 10);
    console.log(curdate);

    return curdate;
  }
  deleteMember(item: any) {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      data: {
        title: "Alert",
        message: "Are you sure you want to delete this member?",
        okbtn: "Yes",
        cancelbtn: "No",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let obj = {
          memberHash: item.hash_id,
          entityHash: this.entityHashId,
        };

        this.loaderservice.showLoader = true;
        this._apiService.deleteEntityMember(obj);
      }
    });
  }

  goviewdetails(rowvalue: any) {
    sessionStorage.setItem("mefrp", rowvalue.email);
    this.router.navigate(["member-details"], {
      relativeTo: this.route,
      queryParams: {
        entityHash: this.entityHashId,
        memberHash: rowvalue.hash_id,
      },
    });
  }

  openViewAttendance(rowvalue: any) {
    this.router.navigate(["view-attendance"], {
      relativeTo: this.route,
      queryParams: {
        entityHash: this.entityHashId,
        memberHash: rowvalue.hash_id,
        mn: rowvalue.name,
      },
    });
  }

  openautoinvoice() {
    let data = {
      entityHash: this.entityHashId,
    };
    this.loaderservice.showLoader = true;
    this.dialogService.openFullScreenDialog(
      AutoInvoicingSettingComponent,
      data,
    );
  }

  openLink(url: string): void {
    window.open(url, "_blank");
  }

  getInvoiceAccess(serviceType: any): boolean {
    if (this.isOwner) return true;
    else {
      const ssa = sessionStorage.getItem(
        SM_CONSTANTS.EMPLOYEE_SHOP_SERVICE_INVOICE_ACCESS,
      );
      const hsa = sessionStorage.getItem(
        SM_CONSTANTS.EMPLOYEE_HOME_SERVICE_INVOICE_ACCESS,
      );
      const vsa = sessionStorage.getItem(
        SM_CONSTANTS.EMPLOYEE_VIRTUAL_SERVICE_INVOICE_ACCESS,
      );

      const bsss = sessionStorage.getItem("shop_service_status");
      const bhss = sessionStorage.getItem("home_service_status");
      const bvss = sessionStorage.getItem("virtual_service_status");

      if (
        (ssa == "1" && bsss != "2" && serviceType == "1") ||
        (hsa == "1" && bhss != "2" && serviceType == "0") ||
        (vsa == "1" && bvss != "2" && serviceType == "2")
      ) {
        return true;
      }
    }

    return false;
  }
}
